import { isEmpty, isNil, uniqueId } from 'lodash';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, Table } from 'tdesign-react';
import SummaryBlock from '../SummaryBlock';

export default function ConfigDiff({ title, data: _data, correct, theme, icon }) {
  const [visible, setVisible] = useState(false);

  const data = useMemo(() => {
    if (!isEmpty(_data)) {
      const ejectArray = _data.map((item) => {
        const tempArr = [];
        const detailArray = Object.entries(item.inconsistentConfigItemDetail || {});
        detailArray.forEach(([key, value], index) => {
          tempArr.push({
            id: uniqueId(),
            configItem: item.configItem,
            inconsistentKey: key,
            inconsistentValue: value,
            configItemLength: index === 0 ? detailArray.length : null,
          });
        });

        return tempArr;
      });

      return ejectArray.flat(); // 转一维
    }
    return [];
  }, [_data]);

  function rowspanAndColspan({ row, colIndex }) {
    if (colIndex === 0 && !isNil(row.configItemLength)) {
      return {
        rowspan: row.configItemLength,
      };
    }
  }

  const doClose = () => setVisible(false);
  return (
    <>
      <SummaryBlock
        theme={theme}
        title={title}
        icon={icon}
        info={
          correct ? (
            <Line>
              <Icon src={require('./images/check-circle.png')} />
            </Line>
          ) : (
            <Line>
              <Icon src={require('./images/x-circle.png')} />
              <Button theme='primary' variant='text' size='small' onClick={() => setVisible(true)}>
                查看原因
              </Button>
            </Line>
          )
        }
      />
      <Dialog header='差异配置' visible={visible} width={900} onClose={doClose} footer={null}>
        <Table
          data={data}
          bordered
          maxHeight='100vh'
          columns={[
            {
              colKey: 'configItem',
              title: '配置项',
            },
            {
              colKey: 'inconsistentKey',
              title: '所属节点',
            },
            {
              colKey: 'inconsistentValue',
              title: '配置值',
            },
          ]}
          rowspanAndColspan={rowspanAndColspan}
        />
      </Dialog>
    </>
  );
}

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

const Line = styled.div`
  display: flex;
  align-items: center;
`;
